import React from 'react';
import { Reveal } from '../ui/Reveal';

export const Contact = () => {
  return (
    <section className="sec" id="contact">
      <div className="cgrid">
        <Reveal>
          <div className="slabel">Get in touch</div>
          <h2 className="ch">Let's<em>work.</em></h2>
          <p className="csub">Have a project in mind? Want to collaborate, contribute or just talk about something you're building? We're easy to reach.</p>
          {/* <a className="cgh" href="https://github.com/imnismay" target="_blank" rel="noreferrer">See all projects on GitHub →</a> */}
        </Reveal>
        <Reveal delay="2">
          <div className="cf">
            <div className="esr" style={{ padding: '16px 0' }}>
              <span className="eslabel">Name</span>
              <span className="esval" style={{ fontSize: 'clamp(22px, 3vw, 28px)' }}>Mayur</span>
            </div>
            <div className="esr" style={{ padding: '16px 0' }}>
              <span className="eslabel">Email</span>
              <a
                href="mailto:info.nismaystudios@gmail.com"
                className="esval"
                style={{
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                  fontSize: 'clamp(18px, 2.5vw, 24px)',
                  wordBreak: 'break-all',
                  color: 'var(--white)'
                }}
                onMouseOver={e => e.target.style.color = 'var(--red)'}
                onMouseOut={e => e.target.style.color = 'var(--white)'}
              >
                info.nismaystudios@gmail.com
              </a>
            </div>
            <div className="esr" style={{ padding: '16px 0' }}>
              <span className="eslabel">Instagram</span>
              <a
                href="https://instagram.com/imnismay"
                target="_blank"
                rel="noreferrer"
                className="esval"
                style={{
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                  fontSize: 'clamp(20px, 2.5vw, 28px)'
                }}
                onMouseOver={e => e.target.style.color = 'var(--red)'}
                onMouseOut={e => e.target.style.color = 'var(--white)'}
              >
                @imnismay
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};